/** here be plugins **/
const rgba2hex = (rgba) => `#${rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/).slice(1).map((n, i) => (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n)).toString(16).padStart(2, '0').replace('NaN', '')).join('')}`;

function getNestedLabelTime(timeline, label) {
	let children = timeline.getChildren(true, false, true),
		i = children.length,
		tl, time;
	while (i--) {
		if (label in children[i].labels) {
			tl = children[i];
			time = tl.labels[label];
			break;
		}
	}
	if (tl) {
		while (tl !== timeline) {
			time = tl.startTime() + time / tl.timeScale();
			tl = tl.parent;
		}
	}
	return time;
}

function percentWithinViewport(el) {
  const element = jQuery( el );

  if( element.css('display') == 'none' ) return 0;
  if( element.css('opacity') == 0 ) return 0;
  if( element.css('visibility') == 'hidden' ) return 0;

  let elementTop = element.offset().top;
  let scrollTop = window.pageYOffset;
  let spaceTop = elementTop - scrollTop;
  let elementHeight = element.height();
  let screenHeight = window.innerHeight;
  let scrollBottom = scrollTop + screenHeight;
  let bottomElement = elementTop + element.height();
  let spaceBottom = bottomElement - scrollBottom;
  let heightInScreen = elementHeight - spaceBottom;
  let percentage;

  if (spaceTop < 0) {
      heightInScreen -= spaceTop * -1;
  }

  if (spaceBottom < 0) {
      heightInScreen -= spaceBottom * -1;
  }

  percentage = heightInScreen / screenHeight * 100;
  percentage = percentage < 0 ? 0 : percentage;

  element.attr('data-percent-viewport', percentage);

  return percentage;
}

function elementInViewport(el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  let width = el.offsetWidth;
  let height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
}